module.exports = {"654028100":"尼勒克镇","654028101":"乌拉斯台镇","654028102":"乌赞镇","654028103":"木斯镇","654028104":"克令镇","654028200":"苏布台乡","654028201":"喀拉苏乡","654028202":"加哈乌拉斯台乡","654028204":"科克浩特浩尔蒙古民族乡","654028207":"喀拉托别乡","654028208":"胡吉尔台乡","654028404":"种蜂场","654028518":"兵团七十九团"}


//////////////////
// WEBPACK FOOTER
// ./src/town/654028.json
// module id = 3277
// module chunks = 0